import apiClient from './apiClient';

class LocationService {
    // ==================== COUNTRY MANAGEMENT ====================
    
    async getCountries(params = {}) {
        try {
            const response = await apiClient.get('/location-management/countries', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching countries:', error);
            throw error;
        }
    }

    async createCountry(countryData) {
        try {
            const response = await apiClient.post('/location-management/countries', countryData);
            return response.data;
        } catch (error) {
            console.error('Error creating country:', error);
            throw error;
        }
    }

    async updateCountry(id, countryData) {
        try {
            const response = await apiClient.put(`/location-management/countries/${id}`, countryData);
            return response.data;
        } catch (error) {
            console.error('Error updating country:', error);
            throw error;
        }
    }

    async deleteCountry(id) {
        try {
            const response = await apiClient.delete(`/location-management/countries/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting country:', error);
            throw error;
        }
    }

    // ==================== STATE MANAGEMENT ====================
    
    async getStates(params = {}) {
        try {
            const response = await apiClient.get('/location-management/states', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching states:', error);
            throw error;
        }
    }

    async createState(stateData) {
        try {
            const response = await apiClient.post('/location-management/states', stateData);
            return response.data;
        } catch (error) {
            console.error('Error creating state:', error);
            throw error;
        }
    }

    async updateState(id, stateData) {
        try {
            const response = await apiClient.put(`/location-management/states/${id}`, stateData);
            return response.data;
        } catch (error) {
            console.error('Error updating state:', error);
            throw error;
        }
    }

    async deleteState(id) {
        try {
            const response = await apiClient.delete(`/location-management/states/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting state:', error);
            throw error;
        }
    }

    // ==================== REGION MANAGEMENT (NEW - CORRECTED) ====================
    
    async getRegions(params = {}) {
        try {
            const response = await apiClient.get('/regions', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching regions:', error);
            throw error;
        }
    }

    async createRegion(regionData) {
        try {
            const response = await apiClient.post('/regions', regionData);
            return response.data;
        } catch (error) {
            console.error('Error creating region:', error);
            throw error;
        }
    }

    async updateRegion(id, regionData) {
        try {
            const response = await apiClient.put(`/regions/${id}`, regionData);
            return response.data;
        } catch (error) {
            console.error('Error updating region:', error);
            throw error;
        }
    }

    async deleteRegion(id) {
        try {
            const response = await apiClient.delete(`/regions/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting region:', error);
            throw error;
        }
    }

    // ==================== CITY MANAGEMENT (UPDATED TO USE CORRECTED API) ====================
    
    async getCities(params = {}) {
        try {
            const response = await apiClient.get('/cities', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching cities:', error);
            throw error;
        }
    }

    async createCity(cityData) {
        try {
            // Use the new corrected cities API endpoint
            const response = await apiClient.post('/cities', cityData);
            return response.data;
        } catch (error) {
            console.error('Error creating city:', error);
            throw error;
        }
    }

    async updateCity(id, cityData) {
        try {
            // Use the new corrected cities API endpoint
            const response = await apiClient.put(`/cities/${id}`, cityData);
            return response.data;
        } catch (error) {
            console.error('Error updating city:', error);
            throw error;
        }
    }

    async deleteCity(id) {
        try {
            // Use the new corrected cities API endpoint
            const response = await apiClient.delete(`/cities/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting city:', error);
            throw error;
        }
    }

    // Get cities by region (helpful for region management)
    async getCitiesByRegion(regionId) {
        try {
            const response = await apiClient.get(`/cities/by-region/${regionId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching cities by region:', error);
            throw error;
        }
    }

    // Get shipping rate between two cities
    async getShippingRate(fromCityId, toCityId, weight = null) {
        try {
            const params = weight ? { weight } : {};
            const response = await apiClient.get(`/cities/${fromCityId}/shipping-rate-to/${toCityId}`, { params });
            return response.data;
        } catch (error) {
            console.error('Error calculating shipping rate:', error);
            throw error;
        }
    }

    // ==================== DROPDOWN DATA (for forms) ====================
    
    async getCountriesDropdown() {
        try {
            const response = await apiClient.get('/location/countries');
            return response.data;
        } catch (error) {
            console.error('Error fetching countries dropdown:', error);
            throw error;
        }
    }

    async getStatesDropdown(countryId = null) {
        try {
            const params = countryId ? { country_id: countryId } : {};
            const response = await apiClient.get('/location/states', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching states dropdown:', error);
            throw error;
        }
    }

    async getCitiesDropdown(stateId = null) {
        try {
            const params = stateId ? { state_id: stateId } : {};
            const response = await apiClient.get('/location/cities', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching cities dropdown:', error);
            throw error;
        }
    }

    async getRegionsDropdown() {
        try {
            const response = await apiClient.get('/regions');
            return response.data;
        } catch (error) {
            console.error('Error fetching regions dropdown:', error);
            throw error;
        }
    }

    // ==================== STATISTICS ====================
    
    async getLocationStats() {
        try {
            const response = await apiClient.get('/location-management/stats');
            return response.data;
        } catch (error) {
            console.error('Error fetching location statistics:', error);
            throw error;
        }
    }

    async getRegionStats() {
        try {
            const response = await apiClient.get('/regions-data/stats');
            return response.data;
        } catch (error) {
            console.error('Error fetching region statistics:', error);
            throw error;
        }
    }
}

export default new LocationService(); 